import React, { useState } from 'react'
import { makeStyles } from 'transfix-ui/core/styles'

const useVideoStyles = makeStyles(() => ({
  videoContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '450px', // Close to full width on smaller screens
    width: '80vw',
    alignItems: 'flex-start',
    textAlign: 'left',
    gap: '5px',
    '@media (min-width: 768px)': { width: '395px' },
  },
  playButton: {
    width: '100%',
    border: 'none',
    padding: '0',
    '&:hover, &:focus': {
      backgroundColor: '#22292b',
    },
  },
  thumbnailImg: {
    width: '100%',
    '&:hover, &:focus': {
      filter: 'brightness(150%)',
    },
  },
  videoTitle: {
    fontFamily: 'Nunito Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: 'normal',
    letterSpacing: '0.15px',
  },
  videoText: {
    height: '130px',
    fontFamily: 'Nunito Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
  },
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modalContent: {
    position: 'relative',
    backgroundColor: '#fff',
    width: '80vw', // 80% of the viewport width
    height: '50vw', // 80% of the viewport height
    maxWidth: '1024px', // Maximum width to control sizing on larger screens
    maxHeight: '576px', // Maximum height based on a standard aspect ratio (16:9)
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeButton: {
    position: 'absolute',
    border: '0px',
    top: '10px',
    height: '45px',
    right: '14px',
    width: '40px',
    color: 'white',
    backgroundColor: '#394657',
    fontSize: '21px',
    fontWeight: 'bold',
    cursor: 'pointer',
    '&:hover, &:focus': {
      backgroundColor: '#394657',
      border: '0px',
      color: 'white',
    },
  },
  video: {
    width: '100%', // Make the video fill the container
    height: '100%', // Make the video fill the container
    maxWidth: '100%', // Ensure the video does not exceed the container's width
    maxHeight: '100%', // Ensure the video does not exceed the container's height
  },
}))

function VideoLightbox({
  videoId,
  videoText,
  videoThumbnailId,
  videoTitle,
}: {
  videoId: string
  videoThumbnailId: string
  videoTitle: string
  videoText?: string
}) {
  const classes = useVideoStyles()
  const [isOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  return (
    <>
      {/* Thumbnail */}
      <div className={classes.videoContainer} key={videoId}>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button onClick={openModal} className={classes.playButton}>
          <img
            src={`https://drive.google.com/uc?export=view&id=${videoThumbnailId}`}
            alt='Video Thumbnail'
            style={{ cursor: 'pointer' }}
            className={classes.thumbnailImg}
          />
        </button>
        <div className={classes.videoTitle}>{videoTitle}</div>
        <div className={classes.videoText}>{videoText}</div>
      </div>

      {/* Lightbox Modal */}
      {isOpen && (
        <div className={classes.container}>
          <div className={classes.modalContent}>
            <button className={classes.closeButton} onClick={closeModal}>
              x
            </button>
            <iframe
              className={classes.video}
              title={videoTitle}
              src={`https://drive.google.com/file/d/${videoId}/preview`}
              width='100%'
              height='auto'
              allow='autoplay'
            />
          </div>
        </div>
      )}
    </>
  )
}

export default VideoLightbox
